/* eslint-disable */
import _ from "lodash/fp";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { BsFiletypePdf } from "react-icons/bs";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import commonHILabels from "../../common/labels/common_hi.json";
import '../../styles/profile.css';
import {
  getAdvertisementTypeDropdownValues,
  getGrievanceTypeDropdownValues,
  getSubGrievanceTypeDropdown,
  grievanceSubmit
} from "../actions/commonActions";
import commonLabels from "../labels/common_en.json";
import { required } from "joi";
const pdfDoc = process.env.PUBLIC_URL + "/images/document.pdf";





const Grievance = () => {

  const { register, control, watch, errors, handleSubmit, reset, setValue } = useForm({
    mode: "onChange"
  });
  let {
    mobileOTPResponse,
    advertisementDropdown,
    sub_grievance_type_list,
    grievance_type_list
  } = useSelector((state) => state.common, shallowEqual);
  let sessionData = JSON.parse(sessionStorage.getItem('session'));
  const userEmail = sessionData.emailId;
  const userMobile = sessionData.mobileNumber;
  const [reloadItem, setReloadItem] = useState(0);
  const [email, setEmail] = useState(userEmail);
  const [mobile, setMobile] = useState(userMobile);
  const [type, setType] = useState('');
  const [advtType, setAdvtType] = useState('');
  const [grievSubType, setGrievSubType] = useState('');
  const [description, setDescription] = useState('');
  const [photo, setPhoto] = useState("");
  const [grievancePhoto, setGrievancePhoto] = useState({
    showGrievancePhoto: "",
    sendGrievancePhotoFile: "",
    showGrievancePhotoBase64: ""
  });
  const [pdf_error_message, setPdf_error_message] = useState(false)
  const [pdf_size, setPdf_size] = useState(false)
  const [pdf_sign, setPdf_sign] = useState(false)
  const [wordCount, setWordCount] = useState(0);
  const [limitReached, setLimitReached] = useState(false);
  const [fileName, setFileName] = useState("No file chosen");
  const [advtFlg, setAdvtFlg] = useState(false);

  const grievanceTypes = useSelector((state) => state.common.grievanceTypes, shallowEqual);


  useEffect(() => {
    setReloadItem(reloadItem);

  }, [reloadItem]);

  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getGrievanceList(userMobile));
    dispatch(getAdvertisementTypeDropdownValues())
    dispatch(getSubGrievanceTypeDropdown(type))
    dispatch(getGrievanceTypeDropdownValues())
  }, [type]);

  const onChangeImage = async (event) => {
    if (event.target.files.length === 0) {
      return;
    }
    const file = event.target.files[0];
    const maxFileSize = 150 * 1024;

    // Check if the file is a PDF
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (fileExtension !== 'pdf') {
      toastr.error(commonLabels);
      setPdf_error_message(true)
      return;
    } else {
      setPdf_error_message(false)
    }

    if (file) {
      setFileName(file.name); // Update the file name in the state
    }

    if (file.size > maxFileSize) {
      toastr.error(commonLabels.COMMON.DOCUMENT_SIZE_NOTE)
      setPdf_size(true)
      return;
    } else {
      setPdf_size(false)
    }

    // Check MIME type
    if (file.type !== "application/pdf") {
      toastr.error("Invalid file type. Please upload a PDF file.");
      setPdf_error_message(true)
      return;
    } else {
      setPdf_error_message(false)
    }
    // Additional check: Read the first few bytes of the file to verify PDF signature
    const arrayBuffer = await file.slice(0, 5).arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);
    const fileSignature = String.fromCharCode(...uint8Array);


    if (fileSignature !== "%PDF-") {
      toastr.error(commonLabels.VALIDATE_MESSAGE.DOCUMENT_SIGN_WARNING);
      setPdf_sign(true)
      return;
    } else {
      setPdf_sign(false)
    }
    setGrievancePhoto({
      showGrievancePhoto: window.URL.createObjectURL(event.target.files[0]),
      sendGrievancePhotoFile: event.target.files[0],
      showGrievancePhotoBase64: ""
    })

    const reader = new FileReader();
    reader.addEventListener('load', () => {
      event.target.value = ""
    });
    reader.readAsDataURL(event.target.files[0]);
  }
  const handleSubmits = (e) => {
    if (setPdf_error_message === true || setPdf_size === true) {
      toastr.warning("Please Select a pdf file to upload")
      return;
    }
    const grievanceTypeVal = grievanceTypes.filter((e) => e.type === type)
    let data = {
      "email": email,
      "mobile": mobile,
      "advtType": advtType,
      "type": grievanceTypeVal[0].id,
      "grievSubType": grievSubType,
      "description": description,
      "photo": photo
    };
    dispatch(grievanceSubmit(data, userMobile));
    // dispatch(getGrievanceList(userMobile));
    clearGrievance()
    reset();
  };

  const clearGrievance = () => {
    setType('');
    setAdvtType('');
    setGrievSubType('')
    setDescription('');
    setPhoto("");
    setPdf_sign(false)
    setPdf_error_message(false)
    setPdf_size(false)
    setFileName("No file chosen")
    setGrievancePhoto({
      showGrievancePhoto: "",
      sendGrievancePhotoFile: "",
      showGrievancePhotoBase64: ""
    });
  }

  let totalCharacters = 500;

  const handleInputChange = (e) => {
    const input = e.target.value;
    const words = input.trim().split(/\s+/);
    // const count = words.filter((word) => word).length;
    const count = input.length;

    if (count <= totalCharacters) {
      setDescription(input);
      setWordCount(count);
      setLimitReached(false);
    } else {
      setLimitReached(true);
    }
  };

  useEffect(() => {
    if (type === "my_account" || type === "new_application") {
      setAdvtFlg(true)
    } else {
      setAdvtFlg(false)
    }
  }, [type])

  return (
    <div className="p-4 f12">
      <div className="p-3 bg-blue ">
        <h5 className="text-white">
          {commonLabels.GRIEVANCE.GRIEVANCE_INFO} : {commonHILabels.GRIEVANCE.GRIEVANCE_INFO}
        </h5>
      </div>
      {/* <div className="row mt-2">
        <div className="pt-4 col-md-12">
          <h5 className="bottom-dotted-line align-left p-1" >
            {commonLabels.GRIEVANCE.GRIEVANCE_DETAILS}: {commonHILabels.GRIEVANCE.GRIEVANCE_DETAILS}
          </h5>
        </div>
      </div> */}

      <div className="col-md-12">
        {/* <GrievanceTable userMobile={userMobile} /> */}
        <div className="row">
          <div className="col-md-12 ">
            <form id="grievance_form" className="mt-5" encType="multipart/form-data" onSubmit={handleSubmit(handleSubmits)}>
              <label>{commonLabels.GRIEVANCE_LABELS.GRIEVANCE_FORM_LINE}</label>
              <input type="hidden" name="email" value={userEmail} />
              <input type="hidden" name="mobile" value={userMobile} />
              <div className="row">

                {/* Grievance Type starts Here */}
                <div className="col-md-4">
                  <label className="LeftText f11">
                    {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_TYPE}
                    <span className="errorText">* </span>
                  </label>

                  <div className="input-group bg-color">
                    <select
                      className="form-select  bg-color"
                      name="type"
                      ref={register({ required: true })}
                      onInput={(e) => setType(e.target.value)}

                    >
                      <option key={0} value="">
                        {commonLabels.SIGN_UP.SELECT}
                      </option>
                      {grievanceTypes?.map((ele, ind) => {
                        return (
                          <option key={ind++} value={ele.type}>
                            {ele.label !== null && ele.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {_.get("type.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                </div>
                {/* Grievance Type Ends Here */}

                {/* Grievance Sub Type Starts Here */}
                <div className="col-md-4">
                  <label className="LeftText f11">
                    {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_SUB_TYPE}
                    {/* <span className="errorText">* </span> */}
                  </label>
                  <div className="input-group bg-color">
                    <select
                      className="form-select  bg-color"
                      name="grievSubType"
                      // ref={register({ required: true })}
                      onInput={(e) => setGrievSubType(e.target.value)}
                    >
                      <option key={0} value="">
                        {commonLabels.SIGN_UP.SELECT}
                      </option>
                      {sub_grievance_type_list.map((ele, ind) => {
                        return (
                          <option key={ind++} value={ele.id}>
                            {ele.label !== null && ele.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {/* {_.get("type.type", errors) === "required" && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )} */}
                </div>
                {/* Grievance Sub Type Ends Here */}

                {/* Advertisement Name start .. Make chnage if need*/}
                <div className="col-md-4">
                  <label className="LeftText f11">
                    {commonLabels.MY_ACCOUNT.ADVERTISEMENT_NAME}
                    {advtFlg && <span className="errorText">* </span>}
                  </label>
                  <div className="input-group bg-color">
                    <select
                      className="form-select  bg-color"
                      name="advtType"
                      ref={register({ required: advtFlg ? true : false })}
                      onInput={(e) => setAdvtType(e.target.value)}
                    >
                      <option key={0} value="">
                        {commonLabels.SIGN_UP.SELECT}
                      </option>
                      {advertisementDropdown.map((ele, ind) => {
                        return (
                          <option key={ind++} value={ele.advertisementNo + "/" + ele.year + "/" + ele.name}>
                            {ele.advertisementNo + " / " + ele.year + " - " + ele.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {advtFlg && !advtType && (
                    <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                </div>
                {/* .Advertisement End Here */}

                {/* Grievance Description start*/}
                <div className="col-md-8">
                  <label className="LeftText f11">
                    {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_DESCRIPTION}
                                        <span className="redColor">*</span>

                  </label>
                  <div className="input-group bg-color griev_desc_input">
                    <textarea
                      type="text"
                      className="form-control"
                      id="description"
                      name="description"
                      rows={10}
                      placeholder={commonLabels.GRIEVANCE_LABELS.GRIEVANCE_DESCRIPTION_PLACEHOLDER}
                      autoComplete="off"
                      value={description}
                      onChange={handleInputChange}
                      ref={register({required:true})}
                    ></textarea>
                  </div>
                  <p className="desc_words" >
                    <span className="successText">Characters: {wordCount}/{totalCharacters}</span>
                    {limitReached && (
                      <span className="errorText">
                        You have reached the limit!
                      </span>
                    )}
                  </p>
                  {_.get("description.type", errors) === "required" && (
                     <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                     </p>
                  )}
                </div>
                {/* Grievance Description End here */}

                {/* Grievance Document uplaod start here */}
                <div className="griev_doc_div col-md-4">
                  <div className="col-md-12">
                    <label className="LeftText f11">
                      {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_PHOTO}
                       <span className="redColor">*</span>
                    </label>
                    <div className="input-group bg-color">
                      <input
                        type="file"
                        className="form-control"
                        id="photo"
                        name="photo"
                        autoComplete="off"
                        accept=".pdf"
                        onChange={(e) => {
                          setPhoto(e.target.files[0])
                          onChangeImage(e);
                        }}
                      />
                    </div>
                    <p>Selected File: {fileName}</p>
                    {!photo && (
                     <p className="errorText">
                      {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                     </p>
                   )}
                    {pdf_error_message && (
                      <p className="errorText">
                        {commonLabels.VALIDATE_MESSAGE.DOCUMENT_FORMAT_WARNING}
                      </p>
                    )}
                    {pdf_sign && (
                      <p className="errorText">
                        {commonLabels.VALIDATE_MESSAGE.DOCUMENT_SIGN_WARNING}
                      </p>
                    )}
                    {pdf_size && (
                      <p className="errorText">
                        {commonLabels.COMMON.DOCUMENT_SIZE_NOTE}
                      </p>
                    )}
                    {(grievancePhoto.showGrievancePhoto || grievancePhoto.showGrievancePhotoBase64) && (
                      <p className="successText">
                        {commonLabels.COMMON.DOCUMENT_SAVE_NOTE}
                      </p>
                    )}
                    <div>
                      {(grievancePhoto.showGrievancePhoto || grievancePhoto.showGrievancePhotoBase64) && (
                        <a
                          href={
                            grievancePhoto.showGrievancePhoto
                              ? grievancePhoto.showGrievancePhoto
                              : `data:application/pdf;base64,${grievancePhoto.showGrievancePhotoBase64}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          title="View PDF"
                          style={{ textDecoration: "none" }}
                        >
                          <BsFiletypePdf
                            className="errorText"
                            size={30}
                            style={{ cursor: "pointer" }}
                          />

                        </a>
                      )}
                    </div>
                  </div>
                </div>
                {/* Grievance Document upload end here */}
                <div className="mt-4 griev_button">
                  <button type="submit" className=" btn btn-primary custom_button  me-2 px-2 griev_button_save" disabled={pdf_error_message || pdf_size || pdf_sign} >{commonLabels.BUTTONS.SAVE}</button>
                  <button onClick={clearGrievance} type="reset" className="btn btn-secondary p-1 griev_button_cancel" >{commonLabels.BUTTONS.CANCEL}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div >
    </div >
  );
}

export default Grievance;
